'use strict';

import Vue from 'vue';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);

Vue.component('pricelists-form', require('../components/pricelists/PricelistsForm.vue').default);

new Vue({
  el: '#pricelists',
  methods: {
    declOfNum(number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
  },
});

String.prototype.replaceAll = function(search, replace) {
  return this.split(search).join(replace);
}
